import axios from '@/mod/axiosMod';

export default {
  // https://km.sankuai.com/page/757676944 文档
  sendMessageForKaSupply(data) {
    return axios.post('/api/v1/contract/send-message', data);
  },
  signAdditional(data) {
    return axios.post('/api/v1/contract/sign-additional', data);
  },
  getAdditional(params) {
    return axios.get('/api/v1/contract/get-additional', {
      params,
    });
  },
  getAdditionalDetail(params) {
    return axios.get('/api/v1/contract/get-additional-detail', {
      params,
    });
  },

  //  https://km.sankuai.com/page/1204793783 文档
  getSubjectChangeInfo() {
    return axios.post('/apigw/api/supplemental-agreement/v1/query-need-supplemental');
  },
  sendMessageForSubjectChange(data) {
    return axios.post('/apigw/api/supplemental-agreement/v1/send-message', data);
  },
  getChangeSubjectAgreementDetail(data) {
    return axios.post('/apigw/api/supplemental-agreement/v1/preview-coop', data);
  },
  signChangeSubjectAgreement(data) {
    return axios.post('/apigw/api/supplemental-agreement/v1/sign-coop', data);
  },

  //  https://km.sankuai.com/page/1208864730 文档
  getRenewCooperationAgreementInfo() {
    return axios.get('/apigw/api/kdb/require-renew-coop');
  },
  sendMessageForRenewCooperationAgreement() {
    return axios.post('/apigw/api/kdb/renew-coop/send-message');
  },
  renewCooperationAgreement({ messageCode }) {
    return axios.post('/apigw/api/kdb/sign-coop', {
      verificationCode: messageCode,
    });
  },
  previewCooperationRenewAgreement() {
    return axios.get('/apigw/api/kdb/preview/coop-info');
  },
};
